<template>
<div class="slices-outer bg-gray-500 relative">
    <div class="slices-inner relative z-20" :class="{'pb-24': lastSlice && lastSlice.name == 'basic_content'}">
        <component v-for="slice in slices" :is="slice.name" :data="slice.data"></component>
    </div>
</div>
</template>

<script>
import { computed } from 'vue';

import anchor_id from './Slices/AnchorId.vue';
import basic_content from './Slices/BasicContent.vue';
import big_link from './Slices/BigLink.vue';
import breakout_box from './Slices/BreakoutBox.vue';
import breakout_feature from './Slices/BreakoutFeature.vue';
import button_row from './Slices/ButtonRow.vue';
import category_feed from './Slices/CategoryFeed.vue';
import extra_space from './Slices/ExtraSpace.vue';
import full_width_photo from './Slices/FullWidthPhoto.vue';
import horizontal_separator from './Slices/HorizontalSeparator.vue';
import intro_with_form from './Slices/IntroWithForm.vue';
import logo_grid from './Slices/LogoGrid.vue';
import link_grid from './Slices/LinkGrid.vue';
import person_grid from './Slices/PersonGrid.vue';
import post_plus_tweet from './Slices/PostPlusTweet.vue';
import priorities_grid from './Slices/PrioritiesGrid.vue';
import stories_map from './Slices/StoriesMap.vue';
import styled_table from './Slices/StyledTable.vue';
import youtube_video from './Slices/YoutubeVideo.vue';

export default {

    props: {
        slices: {
            default: []
        }
    },

    setup(props) {
        let lastSlice = computed(() => {
            return props.slices.length
                ? props.slices.at(-1)
                : null;
        });
        return {
            lastSlice
        }
    },
    
    components: {
        anchor_id,
        basic_content,
        big_link,
        breakout_box,
        breakout_feature,
        button_row,
        category_feed,
        extra_space,
        full_width_photo,
        horizontal_separator,
        intro_with_form,
        logo_grid,
        link_grid,
        person_grid,
        post_plus_tweet,
        priorities_grid,
        stories_map,
        styled_table,
        youtube_video
    }

}
</script>